import api from '../utils/api';

// ===== CLIENT CODE MANAGEMENT =====

export const crmApi = {
  // Client Code Management
  setClientCode: async (clientId, clientCode) => {
    const response = await api.put(`/clients/${clientId}/client-code`, {
      client_code: clientCode
    });
    return response.data;
  },

  findByClientCode: async (clientCode) => {
    const response = await api.get(`/clients/by-code/${clientCode}`);
    return response.data;
  },

  getClientsWithCodes: async () => {
    const response = await api.get('/clients/with-codes');
    return response.data;
  },

  // ===== REVENUE MANAGEMENT =====

  // Get client revenue history
  getClientRevenue: async (clientId, options = {}) => {
    const params = new URLSearchParams();
    if (options.year) params.append('year', options.year);
    if (options.months) params.append('months', options.months);
    
    const response = await api.get(`/clients/${clientId}/revenue?${params}`);
    return response.data;
  },

  // Add revenue record
  addRevenue: async (clientId, revenueData) => {
    const response = await api.post(`/clients/${clientId}/revenue`, revenueData);
    return response.data;
  },

  // Update revenue record
  updateRevenue: async (revenueId, updateData) => {
    const response = await api.put(`/revenue/${revenueId}`, updateData);
    return response.data;
  },

  // Delete revenue record
  deleteRevenue: async (revenueId) => {
    const response = await api.delete(`/revenue/${revenueId}`);
    return response.data;
  },

  // Get revenue trends
  getRevenueTrends: async (clientId, months = 12) => {
    const response = await api.get(`/clients/${clientId}/revenue/trends?months=${months}`);
    return response.data;
  },

  // ===== EMPLOYEE MANAGEMENT =====

  // Get client employee history
  getClientEmployees: async (clientId, options = {}) => {
    const params = new URLSearchParams();
    if (options.year) params.append('year', options.year);
    if (options.months) params.append('months', options.months);
    
    const response = await api.get(`/clients/${clientId}/employees?${params}`);
    return response.data;
  },

  // Add employee count record
  addEmployeeCount: async (clientId, employeeData) => {
    const response = await api.post(`/clients/${clientId}/employees`, employeeData);
    return response.data;
  },

  // Update employee count record
  updateEmployeeCount: async (employeeId, updateData) => {
    const response = await api.put(`/employees/${employeeId}`, updateData);
    return response.data;
  },

  // Delete employee count record
  deleteEmployeeCount: async (employeeId) => {
    const response = await api.delete(`/employees/${employeeId}`);
    return response.data;
  },

  // Get employee trends
  getEmployeeTrends: async (clientId, months = 12) => {
    const response = await api.get(`/clients/${clientId}/employees/trends?months=${months}`);
    return response.data;
  },

  // ===== REPORTING =====

  // Get top clients by revenue
  getTopClients: async (options = {}) => {
    const params = new URLSearchParams();
    if (options.year) params.append('year', options.year);
    if (options.limit) params.append('limit', options.limit);
    
    const response = await api.get(`/reports/top-clients?${params}`);
    return response.data;
  },

  // Get average annual revenue
  getAverageAnnualRevenue: async (year = null) => {
    const params = year ? `?year=${year}` : '';
    const response = await api.get(`/reports/average-annual${params}`);
    return response.data;
  },

  // Get clients by employee size
  getClientsBySize: async (year = null) => {
    const params = year ? `?year=${year}` : '';
    const response = await api.get(`/reports/clients-by-size${params}`);
    return response.data;
  },

  // Get employee statistics
  getEmployeeStatistics: async (year = null) => {
    const params = year ? `?year=${year}` : '';
    const response = await api.get(`/reports/employee-statistics${params}`);
    return response.data;
  },

  // Get revenue per employee analysis
  getRevenuePerEmployee: async (year = null) => {
    const params = year ? `?year=${year}` : '';
    const response = await api.get(`/reports/revenue-per-employee${params}`);
    return response.data;
  }
};

export default crmApi;
